import $ from 'jquery';

var mshHeader = {
    initMshHeader: function(){

        // set the active menu link
        let urlPath = window.location.pathname;
        let menuLinks = $(".msh-header .menu a");
        menuLinks.each(function(){
            var link = $(this).attr("href");
            // If this page path matches the menu link, mark menu link as active
            if( urlPath === link ){
                $(this).addClass("active");
            }
            // If this page is the landing page, test the url path against both
            // / and /landing/ as both are valid landing page URLs
            else if (link === "/landing/" && (urlPath === "/" || urlPath === "/landing/")) {
                $(this).addClass("active");
            }
        });

        // Attach listener on lot dropdown
        let lotDropdown = $(".home-dropdown select");
        lotDropdown.on("change", function(){
            console.log($(this).val());

            var selectedLotId = $(this).val();
            var data = JSON.stringify({
                LotId: selectedLotId
            });
            //Retreieve the communities of the given market area
            $.ajax("/header/setselectedlot",
            {
                contentType: 'application/json' ,
                type: 'POST',
                data: data,
                dataType:'json',
                xhrFields: {
                    withCredentials: true
                },
                success: function (response) {
                    // refresh the page and clear the hash since we don't know if that hash will exist on the new page
                    // loaded for the selected lot
                    window.location.hash = "";
                    window.location.reload();
                },
                error: function (error) {
                    console.log(error);
                }
            })
        });

    }
};


$(function(){
    // Attach listener on lot dropdown
    let lotDropdown = $(".home-dropdown select");
    if( lotDropdown && lotDropdown.length > 0 ) {
        mshHeader.initMshHeader();
    }
    
});

export default mshHeader;